import React from 'react';
import { History, Award, ShieldCheck, Leaf, Truck } from 'lucide-react';

const SpicesAbout = ({ company }) => (
  <div className="bg-gradient-to-br from-green-50 via-emerald-50 to-green-100 text-slate-900 py-12">
    <div className="px-4 sm:px-6 max-w-6xl mx-auto animate-in fade-in slide-in-from-bottom-4 duration-700">
      
      {/* Main Content Grid */}
      <div className="grid md:grid-cols-2 gap-8 items-start mb-16">
        <div className="space-y-6">
          <h2 className="text-3xl lg:text-4xl font-black bg-gradient-to-r from-slate-800 to-emerald-800 bg-clip-text text-transparent leading-tight">
            A Legacy of <span className="text-green-600">Trust</span>
          </h2>
          <p className="text-slate-700 leading-relaxed text-base bg-white/60 backdrop-blur-sm p-5 rounded-2xl border border-green-100/60 shadow-sm">
            {company?.name || "Spice Grains Agro"} has been a cornerstone of D & D Lanka Group for over three decades, ensuring the highest standards through direct producer partnerships.
          </p>

          <div className="grid gap-4">
            {[
              { icon: <History size={20} />, title: "35+ Years", desc: "Global trade excellence." },
              { icon: <Award size={20} />, title: "Lab Certified", desc: "Organic farm-to-export." }
            ].map((item, idx) => (
              <div key={idx} className="flex gap-4 items-center p-4 bg-white/80 backdrop-blur-xl rounded-2xl border-l-4 border-green-400 shadow-md hover:-translate-y-1 transition-all group">
                <div className="bg-gradient-to-br from-green-600 to-emerald-600 p-3 rounded-xl text-white shadow-lg group-hover:scale-105 transition-transform">
                  {item.icon}
                </div>
                <div>
                  <h4 className="font-bold text-slate-900">{item.title}</h4>
                  <p className="text-slate-600 text-sm">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Philosophy Card */}
        <div className="bg-slate-900 rounded-3xl p-8 text-white border border-green-500/30 shadow-xl relative overflow-hidden">
          <div className="absolute top-0 right-0 p-4 opacity-10"><ShieldCheck size={80} /></div>
          <h3 className="text-xl font-bold mb-6 flex items-center gap-3">
            <ShieldCheck size={24} className="text-green-400" />
            Spice Philosophy
          </h3>
          <ul className="space-y-3">
            {[
              "Direct farm partnerships across 10+ countries",
              "Zero chemical processing, sun‑dried only",
              "Sustainable farming practices guaranteed",
              "Full traceability from harvest to delivery"
            ].map((text, i) => (
              <li key={i} className="flex items-start gap-3 text-sm text-slate-300 group">
                <div className="w-1.5 h-1.5 bg-green-400 rounded-full mt-1.5 shrink-0" />
                <span className="group-hover:text-white transition-colors">{text}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Compact Stats Section */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        {[
          { icon: <Leaf size={24} />, val: "50K+", label: "Tons Exported", sub: "30+ countries" },
          { icon: <Truck size={24} />, val: "98.7%", label: "On-Time", sub: "Global logistics" },
          { icon: <Award size={24} />, val: "4.9/5", label: "Client Rating", sub: "500+ partners" }
        ].map((stat, idx) => (
          <div key={idx} className="text-center p-6 bg-white/70 backdrop-blur-md rounded-2xl border border-green-100 shadow-sm hover:shadow-md transition-all">
            <div className="text-green-600 flex justify-center mb-3">{stat.icon}</div>
            <h3 className="text-2xl font-black text-slate-900">{stat.val}</h3>
            <p className="text-sm font-bold text-slate-700">{stat.label}</p>
            <p className="text-xs text-slate-500">{stat.sub}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default SpicesAbout;